export default __webpack_public_path__ + "static/media/circularKnife.b514beb8.png";